import {Component, NgZone, ViewChild} from '@angular/core';
import {NavController, NavParams, Slides, ViewController} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {CONFIG} from "../../../app/config";

import {DataService} from "../../../providers/data-service";
import {TDevicerBios, TLoginTipo} from "../../../app/enum";
import {OpenNativeSettings} from "@ionic-native/open-native-settings";

import {PushService} from "../../../providers/push-service";
import {GeolocationService} from "../../../providers/geolocation-service";
import {LogadoService} from "../../../providers/logado-service";
import {Pro} from "@ionic/pro";

import {ProfileAuthPage} from '../profile-auth/profile-auth';

@Component({
    selector: 'page-loading-erro',
    templateUrl: 'loading-erro.html',
    providers: []
})
export class LoadingErroPage {

    @ViewChild(Slides) slider: Slides;

    rootile: any;

    config: any;

    etapa: number;
    actiun: string;
    titulo: string;
    result: string;
    deploy: any;
    versao: string;
    progress: number;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController,
                public pushService: PushService, public geolocationService: GeolocationService,
                public dataService: DataService,
                public logadoService: LogadoService,
                public params: NavParams, private openNativeSettings: OpenNativeSettings,
                public navParams: NavParams,
                public util: Util,
                private ngZone: NgZone) {

        this.config = CONFIG;

        this.rootile = this.navParams.get('rootile');
        
        this.etapa = this.util.anyParams(0, this.navParams.get('etapa'));
        this.actiun = this.navParams.get('actiun');
        this.titulo = this.navParams.get('titulo');
        this.result = this.navParams.get('result');
        this.deploy = this.navParams.get('deploy');
        this.versao = this.navParams.get('versao');
        

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Loading Auth', '/loading-auth');

        this.prepareOpen();

    }

    ionViewDidLoad() {

        this.util.statusBarColor(this.config.data.brandap ? TStatusBar.sbStyleDefault : TStatusBar.sbStyleLightContent);

    }

    ionViewDidEnter() {

        //this.slider.lockSwipes(true);

        //noinspection JSUnusedGlobalSymbols

        //this.util.statusBarColor
        //NAO colocar nesse evento quando for push
        //evento acontece quando ja terminou a transicao
        //Modal, tem que ser nesse evento, pois a janela sobe
        //e quando esta subindo fica "branco" até completar a
        //transicao de subir a tela.

    }

    ionViewWillEnter() {

        if (this.slider) this.slider.lockSwipes(true);

        if (this.etapa == 0) {
            let push = this.dataService.get('LOADED-NOTIFICA');
            let geol = this.dataService.get('LOADED-LOCATION');
            let appn = this.util.nativeApp();

            let pageStart = (!appn ? 2 : (!push ? 0 : (!geol ? 1 : 2)));
            this.slider.slideTo(pageStart, 0);
        }

    }

    prepareOpen() {

        if (this.actiun == '#TIMEWAIT#') {

            let int = +this.result;
            let timewait = this.util.dateHoje();
            timewait.setSeconds(timewait.getSeconds() + int);
            this.result = '';

            setInterval(() => {
                timewait.setSeconds(timewait.getSeconds() - 1);

                let showwait: string = '';
                showwait += (timewait.getHours()<10 ? '0' : '') + timewait.getHours() + ':';
                showwait += (timewait.getMinutes()<10 ? '0' : '') + timewait.getMinutes() + ':';
                showwait += (timewait.getSeconds()<10 ? '0' : '') + timewait.getSeconds();
                this.result = showwait;

                if (showwait == '00:00:00') window.location.reload();

            }, 1000);

        }

    }

    settingCheck(erro) {

        let onConfir = () => {

            //Atraso, so para "ficar bonito"
            setTimeout(() => {

                //this.slider.lockSwipes(false);
                this.slider.slideNext();
                //this.slider.lockSwipes(true);

                this.openNativeSettings.open("application_details");

            }, 500);

        };

        let onCancel = () => {
            //this.slider.lockSwipes(false);
            this.slider.slideNext();
            //this.slider.lockSwipes(true);
        };

        this.util.alertQuestion(erro.Titulo, erro.Result, 'Continuar', () => onConfir(), false, false, null, onCancel);

    }


    //Notification
    notifyePush() {

        let loading = this.util.loadingDots();
        loading.present();

        this.pushService.pushStart(false)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.slider.lockSwipes(false);
                    this.slider.slideNext();
                    this.slider.lockSwipes(true);

                },
                erro => {

                    this.settingCheck(erro);

                }
            );

    }

    //Geolocation
    geolocation() {

        //Faz a verificação fore e back | watch interval
        this.geolocationService.startTracking()
            .subscribe(
                (location) => {

                    this.handappRoot();

                    //Se quiser toda vez que atualiza a Geolocation mandar para Bridge

                },
                erro => {

                    this.settingCheck(erro);

                });

    }







    updateApp() {

        if (this.etapa == 2) {

            let devicerBios = this.util.deviceSystem();
            if (devicerBios == TDevicerBios.dbIos) this.util.open(this.config.paths.appStoreLink, '_blank', '');
            if (devicerBios == TDevicerBios.dbAndroid) this.util.open(this.config.paths.playStoreLink, '_blank', '');

        }

        if (this.etapa == 3) {

            if (!this.deploy || !this.deploy.Appid || !this.deploy.Channel) {
                this.tituloResult('Deploy', 'Deploy inválido', 0);
                return;
            }

            this.tituloResult('Deploy', 'Iniciando Update', 0);

            Pro.init(this.deploy.Appid, {appVersion: CONFIG.data.version});

            let config = {appId: this.deploy.Appid, channel: this.deploy.Channel};

            //Method manual etapa por etapa
            Pro.deploy.configure(config).then(() => {

                Pro.deploy.checkForUpdate()
                    .then((update) => {

                        if (!update.available) {
                            this.tituloResult('Deploy', 'Update não disponível', null);
                            return;
                        }

                        Pro.deploy.downloadUpdate((progress) => this.tituloResult('Deploy', 'Download', progress * 2))
                            .then(() =>

                                Pro.deploy.extractUpdate()
                                    .then(() => Pro.deploy.reloadApp())
                                    .catch(() => this.tituloResult('Deploy', 'Erro ao extrair app', null))
                            )
                            .catch(() => this.tituloResult('Deploy', 'Erro no download app', null));

                    })
                    .catch(() => this.tituloResult('Deploy', 'Erro no updatecheck app', null));

            });

            //Method manual download, extract, reload
            //Pro.deploy.sync()

        }

    }

    handappInit() {

        (window as any).handappMainInstance.handappInit();

    }

    handappRoot() {

        this.logadoService.logout();

        let object = {etapa: 0, loginTipo: TLoginTipo.loStarting};
        this.navCtrl.setRoot(ProfileAuthPage, object);

    }

    tituloResult(titulo: string, result: string, progress: number) {

        this.titulo = titulo;
        this.result = result;

        this.ngZone.run(() => this.progress = progress);

    }





    dismiss(result: any = null) {

        if (this.viewCtrl.isOverlay) this.viewCtrl.dismiss(result);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/loading-erro/loading-erro.ts